export const subscriber = {
  type: "Subscriber Type",
  types: {
    general: "General",
    workshopParticipant: "Workshop Participant",
    workshopInterest: "Workshop Interest",
    artist: "Artist",
    wanders: "Wanders"
  }
}
